import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UtilService } from './services/util/util.service';
import { Meta } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { TableRouteService } from './services/table-route.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    public router: Router,
    public util: UtilService,
    private metaTagService: Meta,
    private tableRoute: TableRouteService

  ) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        this.tableRoute.getTableToken();
      });
  }

  ngOnInit() {
    this.metaTagService.addTags([
      // { name: 'title', content: 'Jetapps' },
      { name: 'keywords', content: 'Testing, Aja' },
      { name: 'author', content: 'Ryan' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);
  }
  
}
